import React from 'react';
import type { AgentWidgetProps } from 'lib.components/src/components/AgentWidgets';
import './styles.scss';

/**
 * A question the concierge asks in the matching feed: the question in the
 * larger type, the hint under it. Both are copy from the backend — the
 * question is the message text, the hint rides in the meta. The answer is
 * typed in the feed's composer, which knows a question is waiting.
 */
const MatchQuestionWidget: React.FC<AgentWidgetProps> = ({ meta, message }) => (
  <div className="match-question" data-test-id="match-question">
    <p className="match-question__q">{message.message}</p>
    {typeof meta.hint === 'string' && <p className="match-question__hint">{meta.hint}</p>}
  </div>
);

export default MatchQuestionWidget;
